import { Box, CircularProgress } from '@mui/material';
import { colors } from 'styles/colors';

interface Props {
  bgColor?: string;
}

const Loading = ({ bgColor = colors.topBackground }: Props) => {
  return (
    <Box
      sx={{
        width: '100%',
        height: '100%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        backgroundColor: bgColor,
      }}
    >
      <CircularProgress sx={{ color: colors.secondary }} />
    </Box>
  );
};

export default Loading;
